export const scheduleTimeForFirstStep = [
  { label: '10 Mins', value: 10 },
  { label: '60 Mins', value: 60 },
  { label: '3 Hrs', value: 180 },
  { label: '6 Hrs', value: 360 },
  { label: '12 Hrs', value: 720 },
  { label: '1 Day', value: 1440 },
  { label: '2 Days', value: 2880 },
];

export const scheduleTime = [
  { label: '1 Day', value: 1440 },
  { label: '2 Days', value: 2880 },
  { label: '3 Days', value: 4320 },
  { label: '4 Days', value: 5760 },
  { label: '5 Days', value: 7200 },
  { label: '6 Days', value: 8640 },
  { label: '7 Days', value: 10080 },
  { label: '8 Days', value: 11520 },
  { label: '9 Days', value: 12960 },
  { label: '10 Days', value: 14400 },
  { label: '20 Days', value: 28800 },
  { label: '1 Month', value: 43200 },
];

export const immediateDelay = [{ label: 'Immediately', value: 5 }];
